import React from "react";
import CategoriaProdutoServicoService from "../../services/CategoriaProdutoServicoService";
import CrudList from "../../components/forms/custom/CrudList";

export default class ListaCategoriaProdutoServico extends CrudList {

    constructor(props) {
        super(props);

        this.state.crud = {
            service: CategoriaProdutoServicoService,
            labels: {
                title: 'Lista de Categoria(s)',
                btnNewRegister: 'Categoria',
            },
            keyItem: 'idCategoriaProdutoServico',
            urlForm: '/CadCategoriaProdutoServico',
            itensFilter: ["idCategoriaProdutoServico", "nome"],
            searchFormSubmit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderHeader() {
        return (
            <>
                <th className="col-md-2 text-center d-none d-md-table-cell"> Código </th>
                <th className="col-md-10"> Nome </th>
            </>
        );
    }

    getRenderItem(item) {
        return (
            <>
                <td className="text-center d-none d-md-table-cell">{item.idCategoriaProdutoServico}</td>
                <td>{item.nome}</td>
            </>);
    }

    render() {
        return super.render();
    }
}